import type { AudioEventDef } from "@neoweb/audio";

// The hockey audio event vocabulary — every event id the game posts. Bus names in the defs below
// must exist in the bus topology (see ./bus-topology.ts).
export type AudioEventId =
  | "puck.shot"
  | "puck.pass"
  | "puck.boardHit"
  | "puck.postHit"
  | "puck.netHit"
  | "stick.tap"
  | "body.check.land"
  | "body.check.miss"
  | "goalie.save"
  | "match.goal"
  | "match.whistle";

export const eventDefs: Record<AudioEventId, AudioEventDef> = {
  "puck.shot": {
    bus: "sfx.puck",
    url: "/assets/audio/puck_shot.mp3",
    baseVolume: 0.9,
    pitchJitter: 0.04,
    cooldownMs: 25,
  },
  "puck.boardHit": {
    bus: "sfx.puck",
    url: "/assets/audio/puck_board_hit.mp3",
    baseVolume: 0.85,
    pitchJitter: 0.03,
    cooldownMs: 60,
  },
  "match.goal": {
    bus: "sfx.body",
    url: "/assets/audio/match_goal.mp3",
    baseVolume: 1.0,
    pitchJitter: 0,
    cooldownMs: 500,
  },
  "puck.pass": { bus: "sfx.puck", url: "", baseVolume: 0.7, pitchJitter: 0.03, cooldownMs: 40 },
  "puck.postHit": { bus: "sfx.puck", url: "", baseVolume: 0.9, pitchJitter: 0, cooldownMs: 80 },
  "puck.netHit": { bus: "sfx.puck", url: "", baseVolume: 0.7, pitchJitter: 0, cooldownMs: 80 },
  "stick.tap": { bus: "sfx.puck", url: "", baseVolume: 0.5, pitchJitter: 0.05, cooldownMs: 25 },
  "body.check.land": {
    bus: "sfx.body",
    url: "",
    baseVolume: 0.9,
    pitchJitter: 0.04,
    cooldownMs: 50,
  },
  "body.check.miss": {
    bus: "sfx.body",
    url: "",
    baseVolume: 0.5,
    pitchJitter: 0.04,
    cooldownMs: 50,
  },
  "goalie.save": {
    bus: "sfx.goalie",
    url: "",
    baseVolume: 0.85,
    pitchJitter: 0.03,
    cooldownMs: 60,
  },
  "match.whistle": { bus: "ui", url: "", baseVolume: 0.7, pitchJitter: 0, cooldownMs: 200 },
};
